import '../FeatureFlagsContainer.css';
import React, { useEffect, useState } from 'react';

export const ToggleButton = ({ defaultSetting, handleToggle }) => {
  const [toggled, setToggled] = useState(defaultSetting);

  const onToggle = () => {
    const newToggle = !toggled;
    setToggled(newToggle);
    handleToggle(newToggle);
  };

  return (
    <div className="toggle">
      <input className="toggle__input" type="checkbox" defaultChecked={toggled} onClick={onToggle} />
      <span className="toggle__button" />
    </div>
  );
};
